import {Offcanvas} from 'bootstrap';

$(function () {
    const $addProduct = $('#addProduct');

    $addProduct.on('hidden.bs.offcanvas', () => {
        $('#addProduct form')[0].reset();

        $('#productName').val(null).trigger('change');
        $('#productCategory').val(null).trigger('change');
    }).on('shown.bs.offcanvas', () => {
        $('#productName').select2('open');
    });

    $('body .to-buy input[type="checkbox"]').on('change', e => {
        const $checkbox = $(e.target),
            selected = $checkbox.is(':checked');

        $.ajax({
            url: `/api/products/${$checkbox.data('product')}/select`,
            method: 'PATCH',
            data: JSON.stringify({selected}),
            dataType: 'json',
            contentType: 'application/json',
            success: () => {
                location.reload();
            }
        });
    });

    $('body form.add-product').on('submit', e => {
        e.preventDefault();

        const $form = $(e.target);

        $.ajax({
            url: $form.attr('action'),
            method: $form.attr('method'),
            data: $form.serialize(),
            success: () => {
                location.reload();
            }
        });
    });

    $('#productName').select2({
        dropdownParent: $addProduct,
        placeholder: "Wyszukaj",
        theme: "bootstrap-5",
        tags: true,
        allowClear: true,
        ajax: {
            url: '/api/products/search',
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json',
            data: function (params) {
                return JSON.stringify({
                    search: params.term
                });
            },
            processResults: function (data) {
                return {
                    results: data.map(product => ({
                        id: product.name,
                        text: product.name,
                        category: product.category,
                        quantity: product.quantity,
                    }))
                };
            },
            createTag: function (params) {
                const term = $.trim(params.term);

                if (term === '') {
                    return null;
                }

                return {
                    id: term,
                    text: term,
                    newOption: true
                };
            }
        }
    }).on('select2:select', function (e) {
        const selectedProduct = e.params.data;

        if (selectedProduct.category) {
            const categoryOption = new Option(selectedProduct.category.name, selectedProduct.category.id, true, true);
            $('#productCategory').append(categoryOption).trigger('change');
        }

        if (selectedProduct.quantity) {
            $('#quantity').val(selectedProduct.quantity);
        }
    });

    $('#productCategory').select2({
        dropdownParent: $addProduct,
        placeholder: "Kategoria",
        theme: "bootstrap-5",
        tags: true,
        allowClear: true,
        ajax: {
            url: '/api/categories/search',
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json',
            data: function (params) {
                return JSON.stringify({
                    search: params.term
                });
            },
            processResults: function (data) {
                return {
                    results: data.map(category => ({
                        id: category.id,
                        text: category.name
                    }))
                };
            },
            createTag: function (params) {
                const term = $.trim(params.term);

                if (term === '') {
                    return null;
                }

                return {
                    id: '',
                    text: term,
                    newOption: true
                };
            }
        }
    });

    $('#quantitySub, #quantityAdd').on('click', e => {
        const $button = $(e.target),
            $input = $button.closest('div').find('input');

        let value = parseInt($input.val());

        if (isNaN(value)) {
            value = 0;
        }

        if ($button.attr('id') === 'quantityAdd') {
            value++;
        } else {
            value--;
        }

        if (value < 1) {
            value = '';
        }

        $input.val(value);
    });

    $('.list-group .product .edit').on('click', e => {
        e.preventDefault();

        const $product = $(e.target).closest('.product'),
            productName = $product.find('.product-name').text().trim(),
            quantity = parseInt($product.find('.form-check .quantity').text()) || '',
            categoryId = $product.data('category'),
            categoryName = $product.data('category-name');

        const offcanvas = new Offcanvas(document.getElementById('addProduct'));
        offcanvas.show();

        $('#productName').append(new Option(productName, productName, true, true)).trigger('change');
        $('#quantity').val(quantity);

        if (categoryId && categoryName) {
            const categoryOption = new Option(categoryName, categoryId, true, true);
            $('#productCategory').append(categoryOption).trigger('change');
        } else {
            $('#productCategory').val('').trigger('change');
        }
    });

    $('.list-group .product .delete').on('submit', e => {
        e.preventDefault();

        const $form = $(e.target);

        console.log($form.attr('action'));

        $.ajax({
            url: $form.attr('action'),
            method: 'DELETE'
        });
    });

    let startX, currentX, isDragging = false, threshold = 50;

    $('.list-group .product').on('touchstart mousedown', e => {
        if (e.type === "mousedown") e.preventDefault();

        startX = e.touches ? e.touches[0].clientX : e.clientX;
        isDragging = true;
    }).on('touchmove mousemove', function (e) {
        if (!isDragging) return;

        currentX = e.touches ? e.touches[0].clientX : e.clientX;
        let difference = currentX - startX;

        if (difference <= -90) {
            difference = -90;
        }

        $('.list-group .product').not($(this)).removeClass('swiped').find('.product-content').removeAttr('style').removeClass('swiped');

        $(this).find('.product-content').css('transform', `translateX(${difference}px)`);
    }).on('touchend mouseup', function () {
        if (!isDragging) return;
        isDragging = false;

        let difference = currentX - startX;

        if (difference < -threshold) {
            $(this).addClass('swiped');
        } else {
            $(this).removeClass('swiped');
        }

        $(this).find('.product-content').removeAttr('style');
    }).on('touchleave mouseleave', () => {
        if (!isDragging) return;
        isDragging = false;
    });

    // Click outside to reset
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.list-group .product').length) {
            $('.list-group .product').removeClass('swiped')
                .find('.product-content').removeAttr('style');
        }
    });
});
